export const getDomainFromEmail = (email = "") => {
  return email.split("@")?.[1];
};
